// extracted by mini-css-extract-plugin
export default {"loginContent":"Login_loginContent__sijGs","loginForm":"Login_loginForm__Y6uGH"};